(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2655],{

/***/ 22843:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/ultimo-antojo",
      function () {
        return __webpack_require__(28043);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LastWhim; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/seo.tsx
var seo = __webpack_require__(39425);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 9 modules
var lib = __webpack_require__(57800);
;// CONCATENATED MODULE: ./src/queries/products/queries/lastWhimProducts.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LastWhimProducts($params: LastWhimProductsParams!) {\n    lastWhimProducts(params: $params) {\n      id\n      laboratory\n      price\n      activePrinciple\n      lastWhimType\n      lastWhimIndex\n      availability {\n        status\n        discountStock\n        stock\n      }\n      discount {\n        price\n        type\n        stockRestriction\n        dateRestriction\n        listPrice\n      }\n      quantity\n      concentration\n      imagesUrl\n      name\n      slug\n      thumbnailUrl\n      unit\n      format\n      uuid\n      isCheapestActivePrinciple\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LastWhimProductsQuery = function() {
    return (0,lib/* gql */.Ps)(_templateObject());
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/checkout/last-whim/styles.ts


var LastWhimContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        width: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: "10px",
        backgroundColor: "white",
        border: "1px solid #EAEAEA",
        overflow: "hidden",
        marginBottom: "160px"
    }, theme.breakpoints.up("md"), {
        marginBottom: 0
    });
});

// EXTERNAL MODULE: ./src/components/PageWrapper.tsx
var PageWrapper = __webpack_require__(73362);
// EXTERNAL MODULE: ./src/components/Header/SimpleHeader.tsx + 1 modules
var SimpleHeader = __webpack_require__(45629);
// EXTERNAL MODULE: ./src/screens/checkout/styles.ts
var styles = __webpack_require__(58055);
// EXTERNAL MODULE: ./src/screens/checkout/components/OrderSummary.tsx
var OrderSummary = __webpack_require__(42737);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(8002);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(3638);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/components/FreeDeliveryProgressCard.tsx + 1 modules
var FreeDeliveryProgressCard = __webpack_require__(29087);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/last-whim/components/LastWhimProductCard.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    gap: "8px",
    padding: "8px 16px",
    position: "relative",
    borderBottom: "1px solid #EAEAEA",
    alignItems: "center",
    "&:last-child": {
        borderBottom: "none"
    }
});
var SkeletonImg = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "50px",
    height: "50px"
});
var ImgProduct = (0,styled/* default */.Z)("img")({
    height: "50px",
    width: "50px",
    cursor: "pointer",
    objectFit: "contain"
});
var InfoDiv = (0,styled/* default */.Z)("div")({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    minWidth: 0
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "21px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});
var DetailsTextTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "12px",
    fontWeight: 400,
    letterSpacing: "0.4px",
    lineHeight: "18px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#757575"
});
var PriceContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    gap: "4px"
});
var PriceTypography = (0,styled/* default */.Z)(Typography/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "isOldPrice";
    }
})(function(param) {
    var isOldPrice = param.isOldPrice, theme = param.theme;
    return {
        color: isOldPrice ? theme.palette.text.disabled : theme.palette.text.primary,
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "21px",
        textDecoration: isOldPrice ? "line-through" : "none"
    };
});

// EXTERNAL MODULE: ./src/screens/product/utils/extractExtraInfo.tsx
var extractExtraInfo = __webpack_require__(73724);
// EXTERNAL MODULE: ./src/screens/product/hooks/useUpdateQuantity.ts + 1 modules
var useUpdateQuantity = __webpack_require__(10830);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./src/components/Product/ProductQuantityActions.tsx + 1 modules
var ProductQuantityActions = __webpack_require__(29452);
// EXTERNAL MODULE: ./src/hooks/useAddProduct.tsx
var useAddProduct = __webpack_require__(59509);
// EXTERNAL MODULE: ./src/validators/Events/Product.ts
var Product = __webpack_require__(63475);
// EXTERNAL MODULE: ./src/hooks/useEventTracking.tsx + 1 modules
var useEventTracking = __webpack_require__(66630);
// EXTERNAL MODULE: ./src/validators/Events/Interactions/index.ts + 5 modules
var Interactions = __webpack_require__(40813);
// EXTERNAL MODULE: ./src/screens/checkout/last-whim/zustand/lastWhimInteractionsStore.ts
var lastWhimInteractionsStore = __webpack_require__(40256);
;// CONCATENATED MODULE: ./src/screens/checkout/last-whim/components/LastWhimProductCard.tsx


















var currencyFormatter = new CurrencyFormatter/* CurrencyFormatter */.J({
    fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
});
var defaultImage = "/assets/images/default.webp";
var LastWhimProductCard = function(param) {
    var product = param.product, index = param.index, loading = param.loading;
    var ref, ref1, ref2, ref3;
    var track = (0,useEventTracking/* useEventTracking */.A)().track;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,lastWhimInteractionsStore/* useLastWhimInteractionStore */.h)(), addProductAddedToCart = ref4.addProductAddedToCart, addProductCheckedOut = ref4.addProductCheckedOut;
    var ref5 = (0,useAddProduct/* useAddProduct */.h)({
        location: Product/* ProductInteractionLocation.LastWhim */.qv.LastWhim,
        index: index
    }), handleAddProductToCart = ref5.handleAddProduct, addProductToCartLoading = ref5.loading;
    var ref6 = (0,useUpdateQuantity/* useUpdateQuantity */.w)({
        product: product,
        price: product.price,
        location: Product/* ProductInteractionLocation.LastWhim */.qv.LastWhim,
        index: index
    }), addQuantity = ref6.addQuantity, subQuantity = ref6.subQuantity, quantity = ref6.quantity, MAX_AMOUNT = ref6.MAX_AMOUNT;
    var ref7 = (0,react.useState)(product === null || product === void 0 ? void 0 : (ref = product.imagesUrl) === null || ref === void 0 ? void 0 : ref[1]), imageUrl = ref7[0], setImageUrl = ref7[1];
    var hasDiscount = (product === null || product === void 0 ? void 0 : (ref1 = product.discount) === null || ref1 === void 0 ? void 0 : ref1.price) > 0;
    var ref8, ref9;
    var price = hasDiscount ? currencyFormatter.format((ref8 = product === null || product === void 0 ? void 0 : (ref2 = product.discount) === null || ref2 === void 0 ? void 0 : ref2.listPrice) !== null && ref8 !== void 0 ? ref8 : 0) : currencyFormatter.format((ref9 = product === null || product === void 0 ? void 0 : product.price) !== null && ref9 !== void 0 ? ref9 : 0);
    var ref10;
    var discountPrice = currencyFormatter.format((ref10 = product === null || product === void 0 ? void 0 : (ref3 = product.discount) === null || ref3 === void 0 ? void 0 : ref3.price) !== null && ref10 !== void 0 ? ref10 : 0);
    var handleAddProduct = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    addProductAddedToCart(product === null || product === void 0 ? void 0 : product.id, 1, product === null || product === void 0 ? void 0 : product.price);
                    if (!(quantity === 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        handleAddProductToCart({
                            puuid: product === null || product === void 0 ? void 0 : product.uuid,
                            product: product
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    addQuantity();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        handleAddProductToCart,
        product,
        addQuantity,
        quantity
    ]);
    var handleImageError = (0,react.useCallback)(function() {
        setImageUrl(defaultImage);
    }, [
        defaultImage
    ]);
    var handleClick = (0,react.useCallback)(function(elem) {
        track(Interactions/* InteractionEventTypes.LastWhimCheckProduct */.P.LastWhimCheckProduct, {
            product_index_position: index,
            product_id: product === null || product === void 0 ? void 0 : product.id,
            product_name: product === null || product === void 0 ? void 0 : product.name,
            last_whim_type: product === null || product === void 0 ? void 0 : product.lastWhimType,
            last_whim_index: product === null || product === void 0 ? void 0 : product.lastWhimIndex
        });
        addProductCheckedOut(product === null || product === void 0 ? void 0 : product.id);
        void router.push({
            pathname: "/producto/".concat(product.slug),
            query: {
                location: "last_whim"
            }
        });
    }, [
        product,
        router,
        track
    ]);
    var handleSubQuantity = function() {
        subQuantity();
        addProductAddedToCart(product === null || product === void 0 ? void 0 : product.id, -1, product === null || product === void 0 ? void 0 : product.price);
    };
    (0,react.useEffect)(function syncronizeImage() {
        var ref;
        setImageUrl(product === null || product === void 0 ? void 0 : (ref = product.imagesUrl) === null || ref === void 0 ? void 0 : ref[1]);
    }, [
        product === null || product === void 0 ? void 0 : product.imagesUrl
    ]);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimProductCardSkeleton, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgProduct, {
                src: imageUrl,
                onError: handleImageError,
                placeholder: "blur",
                onClick: function() {
                    return handleClick(product);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoDiv, {
                onClick: function() {
                    return handleClick(product);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                        children: product.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsTextTypography, {
                        children: (0,extractExtraInfo/* extractExtraInfo */.UD)(product)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTypography, {
                                isOldPrice: hasDiscount,
                                children: price
                            }),
                            hasDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTypography, {
                                children: discountPrice
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductQuantityActions/* ProductQuantityActions */.O, {
                quantity: quantity,
                addQuantity: handleAddProduct,
                subQuantity: quantity > 0 ? handleSubQuantity : undefined,
                MAX_AMOUNT: MAX_AMOUNT,
                loading: addProductToCartLoading
            })
        ]
    });
};
var LastWhimProductCardSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonImg, {
                variant: "rectangular"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoDiv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleTypography, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "text",
                            width: 300,
                            height: 21
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "text",
                            width: 200,
                            height: 18
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "text",
                            width: 100,
                            height: 21
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(71096);
// EXTERNAL MODULE: ./src/screens/checkout/components/Title.tsx
var Title = __webpack_require__(79728);
// EXTERNAL MODULE: ./src/validators/Events/Screen.ts
var Screen = __webpack_require__(42101);
;// CONCATENATED MODULE: ./src/screens/checkout/last-whim/index.tsx
























function LastWhimPage() {
    var ref;
    var isDesktop = (0,useWindowSize/* useWindowSize */.i)().isDesktop;
    var track = (0,useEventTracking/* useEventTracking */.A)().track;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,useAuth/* useAuth */.a)(), user = ref1.appUser;
    var ref2 = (0,useOrderState/* useOrderState */.h)(), currentOrder = ref2.order;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var ref3;
    var ref4 = (0,useQuery/* useQuery */.aM)(LastWhimProductsQuery(), {
        variables: {
            params: {
                orderUuid: (ref3 = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid) !== null && ref3 !== void 0 ? ref3 : ""
            }
        },
        skip: !(currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid)
    }), lastWhimData = ref4.data, lastWhimLoading = ref4.loading;
    void track(Screen/* ScreenEventType.ScreenLastWhimView */.O.ScreenLastWhimView);
    var subTotal = (0,react.useMemo)(function() {
        var ref;
        return currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails.reduce(function(acc, curr) {
            var ref1;
            return acc + ((ref = (ref1 = curr.product.discount) === null || ref1 === void 0 ? void 0 : ref1.price) !== null && ref !== void 0 ? ref : curr.product.price) * curr.quantity;
        }, 0);
    }, [
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails
    ]);
    var ref5 = (0,react.useMemo)(function() {
        var ref;
        var hasDeliveryCoupons = (user === null || user === void 0 ? void 0 : (ref = user.deliveryCoupons) === null || ref === void 0 ? void 0 : ref.count) > 0;
        if (isLocalVendor || subTotal >= constants/* FREE_SHIPPING_MIN_AMOUNT */.yP) {
            return {
                deliveryCost: 0,
                oldDeliveryCost: 0
            };
        }
        if (hasDeliveryCoupons) {
            return {
                deliveryCost: 0,
                oldDeliveryCost: constants/* DELIVERY_COST */.fI
            };
        }
        return {
            deliveryCost: constants/* DELIVERY_COST */.fI,
            oldDeliveryCost: constants/* DELIVERY_COST */.fI
        };
    }, [
        user === null || user === void 0 ? void 0 : (ref = user.deliveryCoupons) === null || ref === void 0 ? void 0 : ref.count,
        isLocalVendor,
        subTotal
    ]), deliveryCost = ref5.deliveryCost, oldDeliveryCost = ref5.oldDeliveryCost;
    var handleNext = (0,react.useCallback)(function() {
        track(Interactions/* InteractionEventTypes.ClickNext */.P.ClickNext, {
            location: "last_whim"
        });
        void router.push((0,utils/* getRoute */.Bv)("checkoutDelivery").toString());
    }, [
        router
    ]);
    var handleBack = (0,react.useCallback)(function() {
        void router.push((0,utils/* getRoute */.Bv)("homeLoggedIn"));
    }, [
        router
    ]);
    var lastWhimFilteredData = (0,react.useMemo)(function() {
        var ref;
        return lastWhimData === null || lastWhimData === void 0 ? void 0 : (ref = lastWhimData.lastWhimProducts) === null || ref === void 0 ? void 0 : ref.filter(function(product) {
            var ref;
            return [
                "AVAILABLE_24_HRS",
                "AVAILABLE"
            ].includes(product === null || product === void 0 ? void 0 : (ref = product.availability) === null || ref === void 0 ? void 0 : ref.status);
        });
    }, [
        lastWhimData === null || lastWhimData === void 0 ? void 0 : lastWhimData.lastWhimProducts,
        lastWhimLoading
    ]);
    var title = "\xbfOlvidaste algo?";
    var headerTitle = isDesktop ? "" : title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* BackgroundGlobalStyle */.m, {
                mobileColor: "gray"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleHeader/* SimpleHeader */.A, {
                backButton: true,
                homeButton: isDesktop,
                title: headerTitle,
                color: "white",
                handleBack: handleBack
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* PageWrapper */.F, {
                addHeaderPadding: false,
                disableMobilePadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* HorizontalContainer */.bp, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CheckoutCardsContainer */.Q9, {
                            children: [
                                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* CheckoutTitle */.A, {
                                    title: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LastWhimContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeDeliveryProgressCard/* FreeDeliveryProgressCard */.j, {
                                            subTotalCart: subTotal,
                                            loading: lastWhimLoading
                                        }),
                                        lastWhimLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimProductCardSkeleton, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimProductCardSkeleton, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimProductCardSkeleton, {})
                                            ]
                                        }) : lastWhimFilteredData === null || lastWhimFilteredData === void 0 ? void 0 : lastWhimFilteredData.map(function(product, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimProductCard, {
                                                product: product,
                                                index: i
                                            }, product.id);
                                        })
                                    ]
                                })
                            ]
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary/* OrderSummary */.H, {
                            variant: "desktop",
                            isDelivery: !isLocalVendor,
                            deliveryCost: deliveryCost,
                            oldDeliveryCost: oldDeliveryCost,
                            showInsurance: false,
                            showMekiCredits: false,
                            handleNext: handleNext,
                            buttonText: "Continuar al pago",
                            loading: lastWhimLoading
                        })
                    ]
                })
            }),
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary/* OrderSummary */.H, {
                variant: "fixed-bottom",
                isDelivery: !isLocalVendor,
                deliveryCost: deliveryCost,
                oldDeliveryCost: oldDeliveryCost,
                showInsurance: false,
                showMekiCredits: false,
                handleNext: handleNext,
                buttonText: "Continuar al pago",
                loading: lastWhimLoading
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/checkout/ultimo-antojo/index.tsx



function LastWhim() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* SEOHead */.R, {
                title: "Meki \xb7 Ultimo antojo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimPage, {})
        ]
    });
}


/***/ }),

/***/ 29087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ FreeDeliveryProgressCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(8002);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Slider/Slider.js + 6 modules
var Slider = __webpack_require__(50394);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalShippingOutlined.js
var LocalShippingOutlined = __webpack_require__(41865);
;// CONCATENATED MODULE: ./src/components/FreeDeliveryProgressCard.styles.ts



var RootDiv = (0,styled/* default */.Z)("div")({
    width: "100%",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "16px",
    borderBottom: "1px solid #e0e0e0"
});
var TopContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "9px",
    color: "#15365F"
});
var TitleContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "4px"
});
var LocalShippingIcon = (0,styled/* default */.Z)(LocalShippingOutlined/* default */.Z)({
    fontSize: "16px"
});
var TitleTypography = (0,styled/* default */.Z)("div")({
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "16px",
    letterSpacing: "0.15px"
});
var PriceContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
});
var PriceTypography = (0,styled/* default */.Z)("div")({
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "16px",
    letterSpacing: "0.15px"
});
var MessageTypography = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return {
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "16px",
        letterSpacing: "0.15px",
        color: "#15365F",
        "& span": {
            fontWeight: "600",
            color: theme.palette.primary.main
        }
    };
});
var FreeDeliveryProgressSlider = (0,styled/* default */.Z)(Slider/* default */.ZP)(function(param) {
    var theme = param.theme;
    return {
        height: "4px",
        width: "98%",
        "& .MuiSlider-thumb": {
            height: "8px",
            width: "8px"
        },
        "&.Mui-disabled": {
            padding: "2px 0px",
            color: theme.palette.primary.main,
            "& .MuiSlider-track": {
                backgroundColor: theme.palette.primary.main
            }
        }
    };
});

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(3638);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInHours/index.js
var differenceInHours = __webpack_require__(80659);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInMinutes/index.js
var differenceInMinutes = __webpack_require__(12647);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 23 modules
var format = __webpack_require__(83877);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(31807);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/locale/es/index.js + 5 modules
var es = __webpack_require__(90535);
;// CONCATENATED MODULE: ./src/components/FreeDeliveryProgressCard.tsx








var currFormat = new CurrencyFormatter/* CurrencyFormatter */.J({
    fallback: "Gratis"
});
var GetDeliveryMessage = function(param) {
    var subTotalCart = param.subTotalCart, hasDeliveryCoupons = param.hasDeliveryCoupons, expirationDate = param.expirationDate;
    if (hasDeliveryCoupons && expirationDate) {
        var now = new Date();
        var hoursLeft = (0,differenceInHours/* default */.Z)(expirationDate, now);
        var minutesLeft = (0,differenceInMinutes/* default */.Z)(expirationDate, now);
        if (hoursLeft >= 24) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
                children: [
                    "Hasta antes del",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (0,format/* default */.Z)(expirationDate, "d 'de' MMMM 'a las' h:mm a", {
                            locale: es/* default */.Z
                        })
                    }),
                    " ",
                    "el despacho es ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "GRATIS"
                    }),
                    "."
                ]
            });
        } else if (hoursLeft >= 2) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
                children: [
                    "Dentro de las ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "pr\xf3ximas ",
                            hoursLeft,
                            " horas"
                        ]
                    }),
                    " el despacho es",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "GRATIS"
                    }),
                    "."
                ]
            });
        } else if (hoursLeft >= 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
                children: [
                    "Dentro de la ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "pr\xf3xima hora"
                    }),
                    " el despacho es",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "GRATIS"
                    }),
                    "."
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
                children: [
                    "Dentro de los ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "pr\xf3ximos ",
                            minutesLeft,
                            " minutos"
                        ]
                    }),
                    " el despacho es ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "GRATIS"
                    }),
                    "."
                ]
            });
        }
    }
    if (subTotalCart < constants/* FREE_SHIPPING_MIN_AMOUNT */.yP) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
            children: [
                "Agrega",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: currFormat.format(constants/* FREE_SHIPPING_MIN_AMOUNT */.yP - subTotalCart)
                }),
                " ",
                "para tener ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "env\xedo gratis"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
        children: [
            "\xa1Aprovecha y ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "agrega m\xe1s productos!"
            })
        ]
    });
};
var FreeDeliveryProgressCard = function(param) {
    var subTotalCart = param.subTotalCart, loading = param.loading;
    var ref, ref1;
    var appUser = (0,useAuth/* useAuth */.a)().appUser;
    var hasDeliveryCoupons = (appUser === null || appUser === void 0 ? void 0 : (ref = appUser.deliveryCoupons) === null || ref === void 0 ? void 0 : ref.count) > 0;
    var expirationDate = hasDeliveryCoupons ? (0,parseISO/* default */.Z)(appUser === null || appUser === void 0 ? void 0 : (ref1 = appUser.deliveryCoupons) === null || ref1 === void 0 ? void 0 : ref1.minExpirationDate) : null;
    var deliveryCost = hasDeliveryCoupons || subTotalCart >= constants/* FREE_SHIPPING_MIN_AMOUNT */.yP ? 0 : constants/* DELIVERY_COST */.fI;
    var deliveryProgress = hasDeliveryCoupons ? 100 : subTotalCart / constants/* FREE_SHIPPING_MIN_AMOUNT */.yP * 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootDiv, {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            height: "58px",
            width: "100%",
            variant: "rectangular"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalShippingIcon, {
                                    sx: {
                                        fontSize: "18px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                                    children: "Despacho"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTypography, {
                                children: currFormat.format(deliveryCost)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeDeliveryProgressSlider, {
                    value: deliveryProgress,
                    size: "small",
                    disabled: true,
                    "aria-label": "Progreso para despacho gratis"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GetDeliveryMessage, {
                    subTotalCart: subTotalCart,
                    hasDeliveryCoupons: hasDeliveryCoupons,
                    expirationDate: expirationDate
                })
            ]
        })
    });
};


/***/ }),

/***/ 29452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ ProductQuantityActions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/components/Product/ProductQuantityActions.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 14,
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    border: "1px stroke #EAEAEA",
    boxShadow: "0px 0px 5px 0px #D9D9D9",
    borderRadius: "66px",
    maxHeight: "30px"
});
var CartProductCartActionsIconButton = (0,styled/* default */.Z)(IconButton/* default */.Z)({
    padding: 5,
    margin: 0,
    color: "rgb(16	100	177)",
    width: 30,
    height: 30
});
var CartProductCartActionsTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: 18,
    color: "#414046",
    margin: 0,
    maxWidth: 22,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});


// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Delete.js
var Delete = __webpack_require__(41733);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Remove.js
var Remove = __webpack_require__(94895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Product/ProductQuantityActions.tsx






function ProductQuantityActions(param) {
    var quantity = param.quantity, addQuantity = param.addQuantity, subQuantity = param.subQuantity, MAX_AMOUNT = param.MAX_AMOUNT, loading = param.loading;
    var handleAddQuantity = (0,react.useCallback)(function(event) {
        if (loading) return;
        addQuantity();
        event.stopPropagation();
        event.preventDefault();
    }, [
        addQuantity,
        loading
    ]);
    var disabled = loading || quantity >= MAX_AMOUNT;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        onClick: function(event) {
            return event.stopPropagation();
        },
        children: [
            subQuantity && quantity > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductCartActionsIconButton, {
                        style: quantity <= 1 ? {
                            border: "none"
                        } : {},
                        onClick: function(event) {
                            subQuantity();
                            event.stopPropagation();
                        },
                        children: quantity <= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Remove/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductCartActionsTypography, {
                        children: quantity
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductCartActionsIconButton, {
                onClick: handleAddQuantity,
                disabled: disabled,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {})
            })
        ]
    });
}


/***/ }),

/***/ 8002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ FREE_SECOND_SHIPPING_MIN_AMOUNT; },
/* harmony export */   "Nd": function() { return /* binding */ GOOGLE_RATING; },
/* harmony export */   "fI": function() { return /* binding */ DELIVERY_COST; },
/* harmony export */   "qM": function() { return /* binding */ SECOND_DELIVERY_COST; },
/* harmony export */   "yP": function() { return /* binding */ FREE_SHIPPING_MIN_AMOUNT; }
/* harmony export */ });
var FREE_SHIPPING_MIN_AMOUNT = 35000;
var FREE_SECOND_SHIPPING_MIN_AMOUNT = 70000;
var DELIVERY_COST = 3490;
var SECOND_DELIVERY_COST = 990;
var GOOGLE_RATING = 4.8;


/***/ }),

/***/ 40256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useLastWhimInteractionStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(782);





var useLastWhimInteractionStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)(function(set, get) {
    return {
        productsAddedToCart: [],
        productIdsOfPagesChecked: [],
        totalMoneyAddedToCart: 0,
        addProductAddedToCart: function(productId, quantity, price) {
            set(function(state) {
                var existingProduct = state.productsAddedToCart.find(function(product) {
                    return product.productId === productId;
                });
                if (existingProduct) {
                    return {
                        productsAddedToCart: state.productsAddedToCart.map(function(product) {
                            return product.productId === productId ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, product), {
                                unitsAddedToCart: Math.max(product.unitsAddedToCart + quantity, 0),
                                price: price
                            }) : product;
                        })
                    };
                } else {
                    return {
                        productsAddedToCart: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(state.productsAddedToCart).concat([
                            {
                                productId: productId,
                                unitsAddedToCart: quantity,
                                price: price
                            }, 
                        ])
                    };
                }
            });
        },
        addProductCheckedOut: function(productId) {
            set(function(state) {
                return {
                    productIdsOfPagesChecked: Array.from(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(state.productIdsOfPagesChecked).concat([
                        productId
                    ])))
                };
            });
        },
        getLastWhimInteractionSummary: function() {
            var state = get();
            var totalMoney = 0;
            var totalUnits = 0;
            var totalProducts = 0;
            state.productsAddedToCart.forEach(function(product) {
                totalMoney += product.unitsAddedToCart * product.price;
                totalUnits += product.unitsAddedToCart;
                if (product.unitsAddedToCart > 0) {
                    totalProducts += 1;
                }
            });
            return {
                totalMoney: totalMoney,
                totalUnits: totalUnits,
                totalProducts: totalProducts
            };
        },
        cleanValues: function() {
            set(function() {
                return {
                    productsAddedToCart: [],
                    unitsAddedToCart: 0,
                    productIdsOfPagesChecked: []
                };
            });
        }
    };
}, {
    name: "products-interaction-storage",
    partialize: function(state) {
        return {
            productsAddedToCart: state.productsAddedToCart,
            productIdsOfPagesChecked: state.productIdsOfPagesChecked
        };
    }
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,4789,8745,2510,9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(22843); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);